import { AddressCategory } from '@/api'

export default {
  namespaced: true,

  state: ({
    addressCategories: [],
    // address_category DEFINITION
    // id: self.id,
    // name: self.name,
    // address_entries: [
    //   id: self.id,
    //   address_category_id: self.address_category_id,
    //   name: self.user.name,
    //   narrative_phone_id: self.user.narrative_phone_id,
    //   nb_id: self.user.nb_id,
    //   nb_author_id: self.user.nb_author_id,
    //   nb_organization_id: self.user.nb_organization_id.to_i,
    //   description: self.user.description,
    //   icon_img_path: self.user.icon_img_path,
    //   favourite: self.favourite,
    //   memo: self.memo
    // ]
    narrativebookAddresses: [],
    // narrativebook addrssses DIFINITION
    // groups: [
    //   id: int,
    //   name: string,
    //   addresses: [
    //     {
    //       id: int,
    //       narrative_phone_id: string,
    //       nbid: string,
    //       author_id: string,
    //       organization_id: integer,
    //       name: string,
    //       description: string,
    //       icon_image_path: string
    //     }
    //   ],
    // ]
  }),

  mutations: {
    setAddressCategories(state, payload) {
      state.addressCategories = payload
    },

    setNarrativebookAddresses(state, payload) {
      state.narrativebookAddresses = payload
    }
  },

  getters: {
    favourites: state => {
      let favos = []
      state.addressCategories.forEach(category => {
        category.address_entries.forEach(entry => {
          if (entry.favourite) {
            favos.push(entry)
          }
        })
      })
      return favos
    },

    categorySelectable: state => {
      if (state.addressCategories.length > 1) {
        return true
      } else {
        return false
      }
    },

    fetchEntryWithCategory: state => (attr) => {
      console.log('on getter fetchEntryWithCategory')
      console.log(attr)
      for(let category of state.addressCategories) {
        for(let entry of category.address_entries) {
          if (entry.id == attr) {
            return { address_category: category, address_entry: entry }
          }
        }
      }
    },

    storedEntryWithCategory: state => (narrativePhoneID) => {
      for(let category of state.addressCategories) {
        for(let entry of category.address_entries) {
          if (entry.narrative_phone_id == narrativePhoneID) {
            return { address_category: category, address_entry: entry }
          }
        }
      }
      return {}
    },

    notIncludedCategories: state => (narrativePhoneID) => {
      let notIncluded = []
      for(let category of state.addressCategories) {
        for(let entry of category.address_entries) {
          if (entry.narrative_phone_id === narrativePhoneID) {
            notIncluded.push(category)
          }
        }
      }
      return notIncluded
    },

    allCategoryIncluded: (state, getters) => (narrativePhoneID) => {
      if (state.addressCategories.length === getters.notIncludedCategories(narrativePhoneID).length) {
        return true
      }
      return false
    }
  },

  actions: {
    fetch({ commit }) {
      // console.log('addressbook action called, fetch')
      return AddressCategory.fetch().then(res => {
        console.log(res)
        commit('setAddressCategories', res.data.address_categories)
      }).catch(() => {
        commit('setAddressCategories', [])
      })
    },

    create({ dispatch }, payload) {
      AddressCategory.create({ formData: payload }).then(res => {
        console.log(res)
        dispatch('fetch')
      })
    },

    update({ dispatch }, payload) {
      AddressCategory.update({ formData: payload }).then(res => {
        console.log(res)
        dispatch('fetch')
      })
    },

    destroy({dispatch}, payload) {
      return AddressCategory.destroy(payload).then(res => {
        console.log(res)
        dispatch('fetch')
        return res
      })
    },

    createEntry ({ dispatch }, payload) {
      return AddressCategory.createEntry({ formData: payload }).then(() => {
        dispatch('fetch')
      })
    },

    updateEntry ({ dispatch }, payload) {
      return AddressCategory.updateEntry({ formData: payload }).then(res => {
        dispatch('fetch')
        return res
      })
    },

    destroyEntry ({ dispatch }, payload) {
      return AddressCategory.destroyEntry({ targetID: payload }).then(() => {
        dispatch('fetch')
      })
    },

    fetchListFromNarrativebook ({ commit }) {
      return AddressCategory.listFromNarrativebook().then(res => {
        console.log(res.data)
        commit('setNarrativebookAddresses', res.data.groups)
      }).catch(error => {
        console.log('error catch on modules...')
        console.error(error)
        // throw(error)
      })
    }

  }
}